import Skeleton from "react-loading-skeleton";
import { getTimeFormatted } from "../common/TimeFormat";
import { formatCurrency, generateAbbreviation } from "../../lib/util";
import { leftArrowIcon } from "../../assets";
import ImageLoader from "../common/ImageLoader";

export const TransactionDetail = ({
  collection,
  isLoadingSingleTransaction,
  backButton,
  paymentStatusLabels,
  singleTransactionError,
}) => {

  const status = collection?.paymentStatus?.toUpperCase();

  return (
    <div className="transaction-detail-view">
      <button className="details-button" onClick={backButton}>
        <span>{leftArrowIcon}</span>
        <span className="details-btn-text">Back to orders</span>
      </button>

      <div className="transaction-details">
        {/* Loading state */}
        {isLoadingSingleTransaction && !collection && (
          <div className="transaction-detail-skeleton">
            <Skeleton height={30} width={200} style={{ marginBottom: 20 }} />
            <Skeleton
              height={50}
              width="100%"
              count={3}
              style={{ marginBottom: 20 }}
            />
          </div>
        )}

        {singleTransactionError && (
          <div className="trasaction-tabs">
            <p className="error-text">Failed to load transaction details.</p>
          </div>
        )}
        {/* Render details if collection exists */}
        {collection && (
          <>
            {/* Header */}
            <div className="payment-header">
              <h2>Order Date: {getTimeFormatted(collection.orderDate)}</h2>
              {status && paymentStatusLabels[status] && (
                <span
                  style={{
                    backgroundColor: paymentStatusLabels[status].bg,
                  }}
                  aria-label={`Order status: ${paymentStatusLabels[status].label}`}
                >
                  {paymentStatusLabels[status].label}
                </span>
              )}
            </div>

            {/* Payment Items */}
            <div className="payment-items">
              <h3>Payment Items</h3>
              <div className="payment-items-container">
                {Array.isArray(collection.paymentItem) &&
                collection.paymentItem.length > 0 ? (
                  collection.paymentItem.map((item) => {
                   
                    return (
                      <div key={item.productId} className="payment-item">
                        {item.mediaThumb ? (
                          <ImageLoader
                            media={item}
                            skeletonHeight={100}
                            skeletonWidth={100}
                            imageStyle={{
                              width: 100,
                              height: 100,
                              objectFit: "cover",
                              borderRadius: "0.25rem",
                            }}
                            alt={item.name || "Product image"}
                            width={100}
                            height={100}
                          />
                        ) : (
                          <div
                            className="abbrevated-div"
                            style={{
                              width: 100,
                              height: 100,
                              fontSize: "3rem",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "#f0f0f0",
                              borderRadius: "0.25rem",
                            }}
                          >
                            {generateAbbreviation(item.name)}
                          </div>
                        )}
                        {/* Description */}
                        <div className="payment-item-description">
                          <h4 title={item.name}>{item.name}</h4>
                          {item.isVariant && item.variant?.size && (
                            <p>
                              <span className="bold-text">Size:</span>{" "}
                              <span>{item.variant.size}</span>
                            </p>
                          )}
                          {item.isVariant && item.variant?.colorName && (
                            <p>
                              <span className="bold-text">Colour:</span>{" "}
                              <span>{item.variant.colorName}</span>
                            </p>
                          )}
                          <p>
                            <span className="bold-text">Quantity:</span>{" "}
                            <span>{item.unit}</span>
                          </p>
                          <p>
                            <span className="bold-text">Amount:</span>{" "}
                            <span>
                              {formatCurrency(item.amount, item.currency)}
                            </span>
                          </p>
                          <p>
                            <span className="bold-text">Total:</span>{" "}
                            <span>
                              {formatCurrency(item.total, item.currency)}
                            </span>
                          </p>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No payment items found for this order.</p>
                )}
              </div>
            </div>

            {/* Delivery Information */}
            {collection.deliveryInfo &&
              collection.deliveryInfo.deliveryAddress && (
                <div className="payment-items">
                  <h3>Delivery Information</h3>
                  <div className="delivery-info-container">
                    <p>
                      <strong>Address:</strong>
                      <span>{collection.deliveryInfo.deliveryAddress}</span>
                    </p>
                    <p>
                      <strong>Region:</strong>
                      <span> {collection.deliveryInfo.deliveryRegion}</span>
                    </p>
                    <p>
                      <strong>Delivery Number:</strong>
                      <span>
                        {collection.deliveryInfo.intCode}
                        {collection.deliveryInfo.phone}
                      </span>
                    </p>
                    {collection.deliveryInfo.note && (
                      <p className="delivery-note">
                        <strong>Delivery Note:</strong>
                        <span>{collection.deliveryInfo.note}</span>
                      </p>
                    )}
                  </div>
                </div>
              )}

            {/* Order Summary */}
            <div className="payment-items">
              <h3>Order Summary</h3>
              <div className="payment-items-container">
                <p>
                  <span>Sub Total:</span>
                  <span>
                    {formatCurrency(
                      collection.totalAmount,
                      collection.currency
                    )}
                  </span>
                </p>
                <p>
                  <span>VAT ({collection.vatPercentage}% In Product):</span>
                  <span>
                    {formatCurrency(
                      collection.totalAmount * (collection.vatPercentage / 100),
                      collection.currency
                    )}
                  </span>
                </p>
                <p>
                  <strong>Total:</strong>
                  <strong>
                    {formatCurrency(
                      collection.vatIncludedInProductPrice
                        ? collection.totalAmount
                        : collection.totalAmount +
                            collection.totalAmount *
                              (collection.vatPercentage / 100),
                      collection.currency
                    )}
                  </strong>
                </p>
                {status != "PAID" && (
                  <>
                    <p>
                      <span>Amount Paid:</span>
                      <span>
                        {formatCurrency(
                          collection.amountCollected,
                          collection.currency
                        )}
                      </span>
                    </p>
                    <p>
                      <strong>Balance:</strong>
                      <strong>
                        {formatCurrency(
                          collection.amountToBePaid,
                          collection.currency
                        )}
                      </strong>
                    </p>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
